import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-success.png'


const _withScopeId = n => (_pushScopeId("data-v-6307edcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-pdo-apply-to-be-submitted" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "tip" }

import { useI18n } from 'vue-i18n';
  import { onMounted } from 'vue';
  import { ColorVariants } from '@/constants';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('title')), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('subtitle')), 1),
    _createVNode(_component_router_link, {
      replace: "",
      to: { name: 'home' },
      class: "text-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_button, {
          class: "btn-submit",
          pill: "",
          variant: _unref(ColorVariants).primary,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('OK')), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ]),
      _: 1
    })
  ]))
}
}

})